<template>
    <div class="oilDetial">
        <!-- 顶部 -->
        <Top @change-Language="changeLanguage" :type="'detail'" :catalogList="catalogList"></Top>
        <div v-if="showAll">
            <!-- banner -->
            <Banner :bannerText="bannerText" :type="'detail'"  style="margin-top: 7vh;"></Banner>
            <div class="main">
                <!-- 介绍 -->
                <Row class="introBox">
                    <div class="product-card__inner" v-if="!isWideScreen">
                        <div class="leftCard">
                            <div class="leftCardImg">
                                <img :src="synopsis.Pic" alt="">
                            </div>
                            <div class="CardText">
                                <h3 class="CardTitle">
                                    {{synopsis.Title}}
                                    <div style="">{{ synopsis.SubTitle }}</div>
                                </h3>
                                <P style="font-size: 16px; line-height: 1.4;margin-bottom: 20px;">{{synopsis.ExtString1}}</P>
                            </div>
                        </div>
                    </div>

                    <Col span="6" class="product-card__inner" v-if="isWideScreen">
                        <div class="leftCard">
                            <div class="leftCardImg">
                                <img :src="synopsis.Pic" alt="">
                            </div>
                            <div class="CardText">
                                <h3 class="CardTitle">
                                    {{synopsis.Title}}
                                    <div>{{ synopsis.SubTitle }}</div>
                                </h3>
                                <P>{{synopsis.ExtString1}}</P>
                            </div>
                        </div>
                    </Col>
                    <Col :span="isWideScreen ? 15 : 24" :offset="isWideScreen ? 1 : 0" v-html="articleDetail"></Col>
                </Row>
                <Row v-if="this.carousels.length == 1" class="onlyOne">
                    <Col :span="isWideScreen ? 15 : 24" :offset="isWideScreen ? 7 : 0" >
                        <img :src="carouselPic" alt="">
                    </Col>
                </Row>
                <!-- 走马灯 -->
                <div @click="DrawerVal = true" class="openDrawers"  v-if="!isWideScreen && this.catalogue.length > 1">
                    {{message('向左滑动查看更多','Swipe left to see more')}} 
                    <img src="@/assets/OilFeedback.png" alt="" class="feedback" @click="feedBack" v-if="!isWideScreen">
                </div>

                <Drawer placement="left" v-model="DrawerVal" class="drawerssss">
                    <div class="header">{{message('目录','Directory')}}</div>
                    <div class="contain">
                        <div v-for="(item, index) in catalogue" :key="index" class="catalogueItem" @click="checkImg(index)">
                            <div>{{item}}</div>
                            <Icon type="ios-arrow-forward" style="font-size: 18px"/>
                        </div>
                    </div>
                </Drawer>
                <div class="carousel" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" v-if="this.carousels.length > 1" :style="{ height: carouselPic.length <= 1 ? '80vh' : '69vh' }">
                    <Icon type="ios-arrow-back" class="leftIcon" size="60" @click="moveLeft" v-if="showLeftIcons"/>
                    <div v-for="(item, index) in carouselPic" :key="index" class="carouselItem" :style="{ transform: `translateX(${translateX}%)`,height: carouselPic.length <= 1 ? '80vh' : '69vh' }">
                        <img :src="item" alt="">
                    </div>
                    <Icon type="ios-arrow-forward" class="rightIcon" size="60" @click="moveRight"  v-if="showRightIcons"/>
                </div>
                <div class="carouseBottom" v-if="isWideScreen && carouselPic.length > 1">
                    <div class="bottomItem"  v-for="(item, index) in carouselPic" :key="index" :style="{ transform: `translateX(${buttonTranslateX}%)` }" @click="checkImg(index)">
                        <img :src="item" alt="" class="bottomImg">
                        <div v-if="currentIndex === index" :class="{ 'overlay': currentIndex === index }"></div>
                    </div>
                </div>
            </div>
            <Modal v-model="showFeedbackModal" title='留言反馈' :styles='{width:"640px",top:"50px"}' footer-hide>
                <Feedback v-if='showFeedbackModal'/>
            </Modal>
        </div>
        <loading v-if="isLoad"/>
    </div>
</template>

<script>
import Top from './component/cnoilTop.vue'
import Banner from './component/cnoilBanner.vue'
import Feedback from '@/components/common/Feedback'
import loading from '@/components/order/loading'

import {
    mapState,
	mapActions,
    mapMutations
} from 'vuex'

export default {
    data() {
        return {
            // banner
            bannerText: {},
            // 简介
            synopsis: {},
            introduction: {},
            articleDetail: '',
            // 轮播图
            carousels: [],
            catalogue: [],
            carouselPic: [],
            DrawerVal: false,
            showLeftIcons: false,
            showRightIcons: true,
            isThrottled: false,
            // 屏幕宽度
            screenWidth: window.innerWidth,
            // 留言反馈
            showFeedbackModal: false,
            // 走马灯切换
            translateX: 0,
            currentIndex: 0,
            buttonTranslateX: 0,
            lastIndex: 0,
            // 初始显示
            showAll: false,
            // 目录
            catalogList: [],
            // 加载
            isLoad: false,
            load: null
        }
    },
    components: {
        Top,
        Banner,
        Feedback,
        loading,
    },
    created() {
        this.$nextTick(function() {
			this.initData()
		})
    },
    beforeDestroy() {
        if (this.load) {
            clearTimeout(this.load);
        }
    },
    watch: {
        '$route.query.code': 'initData',
        Code() {
            this.initData()
        }
    },
	computed: {
        isWideScreen() {  
            return this.screenWidth >= 768;  
        },
        ...mapState({
            setLanguage: state => state.common.setLanguage,
        }),
	},
    methods: {
        ...mapActions([
			'getPageConfigAction',
			'getPageConfigDetailAction',
            'getArticleDetailAction'
		]),
        ...mapMutations([
			"SET_LANGUAGE",
		]),
        async initData() {
            this.showAll = false
            this.load = setTimeout(() => {
                this.isLoad = true
            }, 500)
            if(!this.setLanguage) {
                this.SET_LANGUAGE('ZH')
            }
            this.changeLanguage()
        },
        async changeLanguage() {
            let Code = this.$route.query?.code
            
            if(Code.endsWith("-English")) {
                this.englishCode = Code
                this.chineseCode = Code.slice(0, -8);
            }else {
                this.englishCode = Code + "-English"
                this.chineseCode = Code
            }

            let pageConfig = this.setLanguage.toUpperCase() === 'ZH' ? this.chineseCode : this.englishCode;
            let page = this.setLanguage.toUpperCase() === 'ZH' ? 'WSChinaOil' : 'WSChinaOil-English'

            // 目录
            let catalog = await this.getPageConfigDetailAction({ page })
            this.catalogList = catalog?.slice(1, -1);

            const res = await this.getPageConfigDetailAction({ page: pageConfig });
            if(res.length > 0) {
                this.bannerText = res[0]
                this.synopsis = res[1]
                this.introduction = res[2]
                this.carousels = res.slice(3)
                this.carouselPic = this.carousels.map( item => item.Pic)
                this.catalogue = this.carousels.map(item => item.Title)
                const articleDetail = await this.getArticleDetailAction(this.introduction.KeyCode)
                this.articleDetail = articleDetail.Content
                this.showAll = true
                clearTimeout(this.load)
                this.isLoad = false
                if(this.carouselPic.length < 2) {
                    this.showRightIcons = false
                }
                this.checkImg(0)
            }
        },

        // 走马灯切换
        moveLeft() {
            if(this.isThrottled) return 
            this.isThrottled = true

            if(this.translateX < 0) {
                this.translateX += 100
                this.currentIndex -= 1
            }else {
                this.translateX = 0
            }
            this.bottomImgMove(this.currentIndex)
            this.showRightIcons = true

            setTimeout(() => {
                this.isThrottled = false;
            }, 800);
        },
        moveRight() {
            if(this.isThrottled) return 
            this.isThrottled = true

            let maxTranslateX = -((this.carouselPic.length - 1) * 100) 
            if(this.translateX > maxTranslateX) {
                this.translateX -= 100
                this.currentIndex += 1
            }
            this.bottomImgMove(this.currentIndex)
            this.showLeftIcons = true

            setTimeout(() => {
                this.isThrottled = false;
            }, 800);
        },
        checkImg(index) {
            if(this.isWideScreen) {
                this.currentIndex = index
                
                this.bottomImgMove(index)
            }else {
                this.currentIndex = index
                this.showRightIcons = true
                this.showLeftIcons = true
                if(index == this.catalogue.length - 1) {
                    this.showRightIcons = false
                }
                if(index == 0) {
                    this.showLeftIcons = false
                }
                this.DrawerVal = false
            }
            this.translateX = -(index * 100)
            
        },
        bottomImgMove(index) {
            const maxMove = -((this.carouselPic.length - 5) * 100)
            let show = 5 - (this.buttonTranslateX/100)
            if(this.buttonTranslateX !== 0 && show - index > 3) {
                this.buttonTranslateX += 100
            }
            if(index > 3 && this.buttonTranslateX > maxMove && this.lastIndex < index ) {
                this.buttonTranslateX -= 100
            }
            if(index == 0) {
                this.buttonTranslateX = 0
            }
            this.showLeftIcons = index > 0;
            this.showRightIcons = index < this.carouselPic.length - 1;
            this.lastIndex = index
        },

        // 滑动切换
        handleTouchStart(event) {
            // 记录触摸开始的位置
            this.startX = event.touches[0].clientX;
            this.isTouching = true;
        },
        handleTouchMove(event) {
            if (!this.isTouching) return;
            // 更新当前触摸位置
            this.currentX = event.touches[0].clientX;
        },
        handleTouchEnd() {
            if (!this.isTouching) return;
            const deltaX = this.startX - this.currentX;
            if (deltaX > 50) {
                this.moveRight();
            } else if (deltaX < -50) {
                this.moveLeft();
            }
            // 重置触摸状态
            this.isTouching = false;
        },

        // 判断屏幕宽度
        handleResize() {
            this.screenWidth = window.innerWidth; 
        },
        // 留言反馈
        feedBack() {
            this.showFeedbackModal = true
        },
        message(ZH,EN){
			return this.setLanguage.toUpperCase() === 'ZH' ? ZH : EN;
		},
    }
}
</script>

<style lang="scss" scoped>
@import "@/style/mixin";
@import "@/style/common";

.oilDetial {
    .main {
        margin: 0 20px;
        .introBox {
            padding: 20px 0;
            margin: 0 auto;
            max-width: 1320px;
            background-color: #fff;
            .product-card__inner {
                font-family:HSCN-Normal;
                letter-spacing: 1px;
                top: -60px;
                text-align: center;
                .leftCard {
                    background-color: #fff;
                    margin: 0 auto;
                    border-radius: 18px;
                    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
                    .leftCardImg {
                        img {
                            margin-top: -30px;
                            margin-bottom: 30px;
                            width: 200px;
                        }
                    }
                    .CardText {
                        padding: 0 30px 45px;
                        .CardTitle {
                            font-size: 20px;
                            margin-top: 0;
                            margin-bottom: 25px;
                            div {
                                font-style: italic;
                                display: block;
                                font-size: 18px;
                                font-weight: 400;
                                margin-top: -8px
                            }
                        }
                        p {
                            font-size: 16px;
                            line-height: 1.4;
                            margin-bottom: 20px;
                        }
                    }
                }
            }
            .downLoadBtn {
                height: 50px;
                color:#008d2c;
                border: 3px solid #008d2c;
                font-weight: bold;
            }
            .downLoadBtn:hover {
                box-shadow: 0 4px 4px rgba(0,0,0, 0.2); 
            }


        }
        .openDrawers {
            padding: 5px 0;
            color: $blue;
            font-weight: bolder;
            .feedback {
                position: fixed;
                right: 0;
                z-index: 100;
                width: 40px;
            }
        }
        .onlyOne {
            text-align: center;
            img {
                height: 50vh;
            }
        }
        .carousel {
            display: flex;
            align-items: center;
            position: relative;
            width: 100%;
            height: 6vh;
            overflow: hidden;
            border-radius: 1vw;
            margin-bottom: 1vh;
            .carouselItem {
                flex: none;
                transition: transform 0.8s cubic-bezier(0.5, 0, 0.5, 1);
                border-radius: 1vw;
                width: 100%;
                height: 69vh;
                display: flex;
                justify-content: center;
                align-items: center;
                img {
                    height: 100%;
                    width: 100%;
                    border-radius: 1vw;
                    object-fit: contain;
                }
            }
            .rightIcon, .leftIcon {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: #545454;
                z-index: 10;
                cursor: pointer;
            }
            .rightIcon:hover, .leftIcon:hover {
                color: #fff;
                background-color: rgba(84, 84, 84, 0.5);
            }
            .rightIcon {
                right: 0;
            }
            .leftIcon {
                left: 0;
            }
        }
        .carouseBottom {
            display: flex;
            flex-wrap: nowrap;
            overflow: hidden;
            width: calc(100vw - 40px);
            height: 21vh;
            margin-bottom: 1vh;
            .bottomItem {
                box-sizing: border-box;
                padding: 5px;
                position: relative;
                transition: transform 0.8s cubic-bezier(0.5, 0, 0.5, 1);
                will-change: transform;
                cursor: pointer;
                height: 100%;
                width: calc(20vw - 8px);
                .bottomImg {
                    width: calc(20vw - 18px);
                    height: 100%;
                    border-radius: 1vh;
                    object-fit: cover;
                }
                .overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: calc(20vw - 8px);
                    height: 100%;
                    background-color: rgba(0, 0, 0, 0.5);
                    border-radius: 1vh;
                    z-index: 1;
                }
            }
        }

        @media (max-width: 768px) {
            margin: 0 10px;
            .introBox {
                margin-top: 60px;
                padding: 10px 0;
                .product-card__inner {
                    width: 100%;
                    margin-bottom: 20px;
                }
            }
        }
    }
}
</style>


<style lang="scss">
.drawerssss {
    .ivu-drawer-body {
        padding: 16px 0;
        background-color: #f4f4f4;
    }
    .header {
        text-align: center;
    }
    .contain {
        margin-top: 5px;
        .catalogueItem {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 5px 10px ;
            margin: 5px 0;
            background-color: #fff;
        }
    }
}

</style>